import { SocialFriendItem } from './SocialFriendItem';

export class SocialFriendsList extends PIXI.Container {
    private icons: SocialFriendItem[] = [];

    constructor() {
        super();

        const back = new PIXI.Graphics();
        back.beginFill(0x000000, 1);
        back.drawRect(0, 0, 800, 500);
        this.addChild(back);

        this.visible = false;
        this.interactive = true;
        this.buttonMode = true;
        this.on('pointerdown', () => {
            this.visible = false;
        });
    }

    init(items: []) {
        console.log('SicialFriendList init', items)
        this.visible = true;
        for (let i = 0; i < this.icons.length; i++) {
            this.removeChild(this.icons[i]);
        }
        this.icons = [];
        let px = 10;
        let py = 10;
        for (let i = 0; i < (items.length > 28 ? 28 : items.length); i++) {
            const item = new SocialFriendItem(items[i]);
            item.x = px;
            item.y = py;
            px += 102;
            if (i % 7 === 6) {
                px = 10;
                py += 102;
            }
            this.addChild(item);
        }
    }


}